export const MIN_WORD_LENGTH = 3
export const MAX_GRID_SIZE = 25
export const MIN_GRID_SIZE = 5
export const BLACK_CELL_RATIO = 1 / 4
export const MAX_PARALLEL_ROWS = 2
export const MAX_PARALLEL_SPAN = 4
export const CSP_TIMEOUT_MS = 8_000
export const CLUE_BATCH_SIZE = 20
export const MIN_WORD_SCORE = 40

export const PUZZLE_TYPES = ["quick", "cryptic", "quiptic", "desi"] as const
export type PuzzleType = (typeof PUZZLE_TYPES)[number]

export const GRID_STYLES = ["american", "british"] as const
export type GridStyle = (typeof GRID_STYLES)[number]

export const BRITISH_SUPPORTED_SIZES = [13, 15] as const

export const GRID_SIZES = [5, 7, 9, 11, 13, 15, 17, 19, 21] as const
